import { DateTime } from "luxon"
import TableMaker, { TableMakerType } from "../assets/TableMaker"
import { CheckCircle, Error } from "@mui/icons-material"
import PreLoader from "../PreLoader"
import { Alert } from "@mui/material"
import { useAxios } from "../../hooks/useAxios"
import { ViewAutomatedServiceLastUpdate } from "./types"

export default function ServicesLastUpdate({ id }: { id: number }) {

  const { data, error, isLoading } = useAxios<ViewAutomatedServiceLastUpdate[]>(`${process.env.REACT_APP_NOTIFIER_URL}/automated-services-last-update/${id}`)

  const getTriggerStatus = (fail: boolean | null) => {
    if (fail == false) return <CheckCircle color='success' />
    return <Error color='error' />
  }

  const format: TableMakerType<ViewAutomatedServiceLastUpdate>[] = [
    { field: 'last_update', header: 'Date', width: 1, renderComponent: (value) => DateTime.fromISO(String(value)).toFormat('dd-LLL-yy') },
    { field: 'trigger_name', header: 'Trigger', width: 4 },
    { field: 'fail', header: 'Status', width: .5, renderComponent: (value) => getTriggerStatus(Boolean(value)) },
  ]

  if (isLoading) return <PreLoader />
  if (error) return <Alert severity='error'>Could not load last updates</Alert>

  return <TableMaker
    data={data || []}
    format={format}
  />
}